module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_c('div', {
    staticClass: "product-main"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("一、是否为下列机构")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "padding": "10px"
    }
  }, [_vm._v("\n          为《证券期货投资者适当性管理办法》第八条第（一）款机构面向投资者发行的证券公司资产管理产品、基金管理公司及其子公司产品、期货公司资产管理产品、银行理财产品、保险产品、信托产品、经行业协会备案的私募基金，及第（一）款规定机构发行的其它理财产品；\n          或者为第（三）款规定的社会保障基金、企业年金等养老基金、慈善基金等社会公益基金\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isFollowProduct.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isFollowProduct, "checked", $$v)
      },
      expression: "data.isFollowProduct.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": "",
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": "",
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.isFund ? '二、私募基金投资者，最近三个月月末资产均超过（含）人民币1000万元' :
    '二、资产管理计划投资者，为最近 1 年末净资产不低于 1000 万元的法人单位') + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.orgAssetSize.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.orgAssetSize, "checked", $$v)
      },
      expression: "data.orgAssetSize.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("三、是否存在实际控制关系？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isControllingShareholder.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "checked", $$v)
      },
      expression: "data.isControllingShareholder.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isControllingShareholder.checked === '是'),
      expression: "data.isControllingShareholder.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isControllingShareholder.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isControllingShareholder, "description", $$v)
      },
      expression: "data.isControllingShareholder.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("四、交易实际受益人？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "checked", $$v)
      },
      expression: "data.transactionActualBeneficiary.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "本机构"
    }
  }, [_c('my-check-style', [_vm._v("本机构")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "其他机构或个人"
    }
  }, [_c('my-check-style', [_vm._v("其他机构或个人")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.transactionActualBeneficiary.checked === '其他机构或个人'),
      expression: "data.transactionActualBeneficiary.checked === '其他机构或个人'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.transactionActualBeneficiary.description),
      callback: function($$v) {
        _vm.$set(_vm.data.transactionActualBeneficiary, "description", $$v)
      },
      expression: "data.transactionActualBeneficiary.description"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px",
      "background": "#fff",
      "border-bottom": "1px solid #ebecf5"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("五、是否有不良诚信记录？")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('checker', {
    attrs: {
      "default-item-class": "check-item",
      "selected-item-class": "check-item-selected"
    },
    model: {
      value: (_vm.data.isBadFaith.checked),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "checked", $$v)
      },
      expression: "data.isBadFaith.checked"
    }
  }, [_c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "是"
    }
  }, [_c('my-check-style', [_vm._v("是")])], 1), _vm._v(" "), _c('checker-item', {
    attrs: {
      "disabled": _vm.type === 0,
      "value": "否"
    }
  }, [_c('my-check-style', [_vm._v("否")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data.isBadFaith.checked === '是'),
      expression: "data.isBadFaith.checked === '是'"
    }]
  }, [_c('group', [_c('x-textarea', {
    attrs: {
      "placeholder": "请说明",
      "readonly": _vm.type === 0,
      "rows": 1,
      "autosize": ""
    },
    model: {
      value: (_vm.data.isBadFaith.description),
      callback: function($$v) {
        _vm.$set(_vm.data.isBadFaith, "description", $$v)
      },
      expression: "data.isBadFaith.description"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('submit-button', {
    attrs: {
      "disabled": _vm.type === 0
    },
    on: {
      "click": _vm.$_product_submit
    }
  }, [_vm._v("下一步")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-209c6b5d"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InvestorInfo/Product/Question.vue
// module id = 1027
// module chunks = 1